export const weekLength = 1000 * 60 * 60 * 24 * 7;
export const path = window.location.origin + window.location.pathname;
